(function () {
  if (window.__tdParcelamentoInit) return;
  window.__tdParcelamentoInit = true;

  function formatMoney(cents) {
    if (window.geckoShopify && typeof geckoShopify.formatMoney === 'function') {
      return geckoShopify.formatMoney(cents);
    }
    var value = (Math.round(Number(cents) || 0) / 100).toFixed(2).split('.');
    value[0] = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + value[0] + ',' + value[1];
  }

  function jurosNum(raw) {
    return parseFloat(String(raw == null ? '0' : raw).replace(',', '.')) || 0;
  }

  function parcelaCents(price, n, juros) {
    return Math.round((Number(price) * (1 + jurosNum(juros) / 100)) / n);
  }

  function parseJsonAttr(el, name) {
    try {
      return JSON.parse(el.getAttribute(name) || '{}');
    } catch (e) {
      return {};
    }
  }

  function currentVariantId(root) {
    var prefix = (root.getAttribute('data-td-id') || '').replace(/^\d+/, '') || '_ppr';
    var select = document.getElementById('product-select' + prefix) || document.querySelector('select.product-select_pr');
    return select && select.value ? String(select.value) : '';
  }

  function currentPrice(root, variants) {
    var id = currentVariantId(root);
    if (id && variants[id] && variants[id].price != null) return Number(variants[id].price);
    return Number(root.getAttribute('data-td-price') || 0);
  }

  function updateRoot(root) {
    var variants = parseJsonAttr(root, 'data-td-variants');
    var jurosMap = parseJsonAttr(root, 'data-td-juros');
    var price = currentPrice(root, variants);
    var geral = Number(root.getAttribute('data-td-geral') || 12);
    var pixPct = Number(root.getAttribute('data-td-pix') || 0);
    var boletoPct = Number(root.getAttribute('data-td-boleto') || 0);

    var installmentEl = root.querySelector('[data-td-installment]');
    if (installmentEl) {
      installmentEl.textContent = formatMoney(parcelaCents(price, geral, jurosMap[String(geral)]));
    }

    var id = currentVariantId(root);
    var compare = id && variants[id] ? Number(variants[id].compare || 0) : 0;
    var wrap = root.parentNode;
    var badge = wrap && wrap.querySelector ? wrap.querySelector('[data-td-badge]') : null;
    if (badge) {
      if (compare > price) {
        var save = compare - price;
        var pct = Math.round((save * 100) / compare);
        var moneyEl = badge.querySelector('[data-td-save-money]');
        var pctEl = badge.querySelector('[data-td-save-pct]');
        if (moneyEl) moneyEl.textContent = formatMoney(save);
        if (pctEl) pctEl.textContent = pct + '%';
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    var cashEls = root.querySelectorAll('[data-td-cash]');
    for (var i = 0; i < cashEls.length; i++) cashEls[i].textContent = formatMoney(price);

    var rows = root.querySelectorAll('[data-td-n]');
    for (var r = 0; r < rows.length; r++) {
      var n = Number(rows[r].getAttribute('data-td-n'));
      var jv = jurosMap[String(n)] || '0';
      var val = parcelaCents(price, n, jv);
      var valEl = rows[r].querySelector('[data-td-n-val]');
      var totalEl = rows[r].querySelector('[data-td-n-total]');
      if (valEl) valEl.textContent = formatMoney(val);
      if (totalEl) totalEl.textContent = formatMoney(jurosNum(jv) === 0 ? price : val * n);
    }

    var pixEl = root.querySelector('[data-td-pix-total]');
    if (pixEl) pixEl.textContent = formatMoney(Math.round(price * (1 - pixPct / 100)));

    var boletoEl = root.querySelector('[data-td-boleto-total]');
    if (boletoEl) boletoEl.textContent = formatMoney(Math.round(price * (1 - boletoPct / 100)));
  }

  function updateAll() {
    var roots = document.querySelectorAll('[data-td-parcel]');
    for (var i = 0; i < roots.length; i++) updateRoot(roots[i]);
  }

  function closeModal(backdrop) {
    if (!backdrop) return;
    backdrop.classList.remove('is-open');
    if (!document.querySelector('.td-parcel-backdrop.is-open')) {
      document.documentElement.classList.remove('td-parcel-open');
    }
  }

  function openModal(backdrop) {
    if (!backdrop) return;
    backdrop.classList.add('is-open');
    document.documentElement.classList.add('td-parcel-open');
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-td-open]');
    if (openBtn) {
      e.preventDefault();
      openModal(openBtn.closest('[data-td-parcel]').querySelector('[data-td-backdrop]'));
      return;
    }
    var closeBtn = e.target.closest('[data-td-close]');
    if (closeBtn) {
      e.preventDefault();
      closeModal(closeBtn.closest('[data-td-backdrop]'));
      return;
    }
    if (e.target.classList && e.target.classList.contains('td-parcel-backdrop')) {
      closeModal(e.target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.td-parcel-backdrop.is-open');
      if (open) closeModal(open);
    }
  });

  var $ = window.jQuery_T4NT || window.jQuery;
  if ($) {
    $(document.body).on('change', 'select.product-select_pr, select[name="id"]', updateAll);
    $(document.body).on('refresh_currency', updateAll);
  } else {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('select.product-select_pr, select[name="id"]')) {
        updateAll();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
})();
